import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router';
import { FormProvider, RHFTextField } from 'src/components';
import { Paths } from 'src/config';
import { useEditTrainerMutation } from 'src/redux/services/TrainerServices';
import * as Yup from 'yup';

const TrainerEditValidationSchema = Yup.object({
  name: Yup.string().required('نام اجباری می باشد'),
  desc: Yup.string(),
});

export const TrainerEditForm = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { trainerID } = useParams();
  const [editTrainer, { isLoading }] = useEditTrainerMutation();
  const methods = useForm({
    defaultValues: {
      name: state?.name,
      desc: state?.desc,
    },
    resolver: yupResolver(TrainerEditValidationSchema),
  });
  const { handleSubmit } = methods;

  async function onSubmit(values) {
    try {
      const body = {
        name: values.name,
        desc: values.desc !== '' ? values.desc : undefined,
        teacherID: trainerID,
      };
      await editTrainer(body).unwrap();
      enqueueSnackbar(`مدرس ${values.name} ویرایش شد`, { variant: 'success' });
      navigate(Paths.trainer.list.path);
    } catch (error) {
      console.log('TRAINER EDIT ERROR', error);
      enqueueSnackbar(`مدرس ${values.name} ویرایش نشد`, { variant: 'error' });
    }
  }

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <RHFTextField name={'name'} label={'نام'} />
        </Grid>
        <Grid item xs={12}>
          <RHFTextField name={'desc'} label={'توضیحات'} multiline minRows={5} />
        </Grid>
        <Grid item>
          <Button variant="contained" disabled={isLoading} type="submit">
            {Paths.trainer.edit.title}
          </Button>
        </Grid>
      </Grid>
    </FormProvider>
  );
};
